import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import TransferToDepartment from '../../components/modal/TransferToDepartment';
import { editReceivedRecordTag, refreshCurrentRecords } from '../../actions/records';
import { rowSelected } from '../../actions/inboxTableActions';
import { getOrganizationDepartments } from '../../actions/userProfile';

class TransferToDepartmentDialog extends Component {
  render() {
    const { editReceivedRecordTag: editTag } = this.props;
    return (
      <div>
        <TransferToDepartment
          // ModalRoot hands every dialog its whole props bag (it spreads
          // `{...this.props}` into the resolved modal component), so this container
          // forwards that bag wholesale rather than enumerating props it does not
          // own and would silently drop as ModalRoot's own props change. Same shape
          // as ShareReferralDialog and AddTaskTemplateDialog.
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...this.props}
          editTag={editTag}
        />
      </div>
    );
  }
}

TransferToDepartmentDialog.propTypes = {
  editReceivedRecordTag: PropTypes.func.isRequired,
};

export default connect(null, {
  rowSelected,
  editReceivedRecordTag,
  getOrganizationDepartments,
  refreshCurrentRecords,
})(TransferToDepartmentDialog);
